import axios from "axios";
import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const Delete = () => { // 1. Missing component wrapper
  const [error, setError] = useState(false);
  
  const location = useLocation();
  const navigate = useNavigate();

  // Gets ID from URL (e.g., /delete/15)
  const bookId = location.pathname.split("/")[2];

  const handleDelete = async (e) => {
    e.preventDefault();
    try {
      // 2. Changed .put to .delete to match backend
      await axios.delete(`https://api.kamulyaan.id/books/${bookId}`);
      navigate("/");
    } catch (err) {
      console.log(err);
      setError(true);
    }
  };

  return (
    <div className="form">
      <h1>Delete Book {bookId}</h1>
      <p>Are you sure you want to delete this book?</p>
      
      {/* 3. Button calls handleDelete */}
      <button className="formButton" onClick={handleDelete}>
        Yes, Delete
      </button>
      
      <Link to="/">Cancel</Link>
      {error && <span style={{color: "red"}}>Something went wrong!</span>}
    </div>
  );
};

export default Delete;